<template>
  <div class="w-full top-header bg-white flex justify-between items-center">
    <div class="ml-6">
      <img class="w-44" src="/images/logo.png" />
      <img class="mt-2 ml-5" src="/images/cloudprinter-logo.svg" alt="Cloudprinter" height="87" width="100" />
    </div>
    <div>
      <div class="mr-6">
        <el-dropdown>
          <div class="flex items-center">
            <div class="mr-3">
              <el-avatar :size="30" icon="el-icon-user-solid"></el-avatar>
            </div>
            <span class="el-dropdown-link font-semibold">
              <span>Admin</span><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="logout()">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import router from '../../app-router';
import { authService } from '../../services';

export default defineComponent({
  name: 'TopNavComponent',
  methods: {
    logout: async function () {
      authService.logout();
      await router.push('/');
    },
  },
});
</script>

<style lang="scss" coped>
.top-header {
  height: 80px;
  border-bottom: 1px solid rgba(224, 224, 224, 0.7);
}
</style>
